import { call, put, takeLatest } from "redux-saga/effects";
import { FORGOT_PASSWORD_REQUEST } from "../../actionTypes/forgotPassword";
import {
  forgotPasswordSuccess,
  forgotPasswordFailure,
} from "../../action/forgotPassword";
import { forgotPasswordApi } from "../../../com/forgotpassword";
import { BaseResponse } from "../../response";
import { API_CODES } from "../../../constants";

interface ForgotPasswordAction {
  type: typeof FORGOT_PASSWORD_REQUEST;
  payload: { emailOrPhone: string };
}

export function* forgotPasswordWorker(
  action: ForgotPasswordAction,
): Generator<unknown, void, BaseResponse> {
  try {
    const response = yield call(forgotPasswordApi, action.payload);

    if (response.status === API_CODES.SUCCESS_CODE || response.status === "SUCCESS") {
      yield put(forgotPasswordSuccess(response.statusinfo.message));
    } else {
      yield put(forgotPasswordFailure(response.statusinfo.message));
    }
  } catch {
    yield put(forgotPasswordFailure("Something went wrong"));
  }
}

export function* forgotPasswordSaga(): Generator {
  yield takeLatest(FORGOT_PASSWORD_REQUEST, forgotPasswordWorker);
}
